export default "__VITE_ASSET__CYS1MHxH__"